import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "../../css/course-page.css";
import "../../css/main-mobile-view.css";
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import Courseschedule from '../Landing/Subcomponent/courseschedule';
import Intrestedinprogram from './intrestedinprogram';

class DataScience extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol className="breadcrumb def-z course-m">
                        <li className="breadcrumb-item"><Link href="#"> <i className="icon-home"></i>HOME </Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Post Graduate Program in Data Science</li>
                    </ol>
                </div>
                <section className="course-header bg-blue1" id="course-header">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg">
                            <h1>Post Graduate Program in <br />Data Science </h1><br />
                            <p>Accelerate your Career. Stay Ahead of the Curve </p>
                            <br /> <br /><br />
                            <div className="form-group">
                                <Link className="btn btn-md enroll-btn">Enroll Now </Link>
                                <button type="button" className="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn" data-target="#myModal" >Download brochure</button> <br /> <br />
                                <h3> Online Live Training</h3><br /> <br />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-1"></div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                            <br />
                            <p>Jointly Delivered by </p>
                            <br />
                            <ul>
                                <li>   <img alt="executive" width="" src="/assets/images/isi.svg" /></li>

                                <li>  <img alt="executive2" width="" src="/assets/images/epn.svg" /> </li>
                            </ul>
                        </div>
                    </div>
                </section>
                <div className="course-main-contains def-z" >
                    <div className="card">
                        <div className="row contanint-display">
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i className="fa fa-calendar" ></i>&nbsp;&nbsp;&nbsp;6 MONTHS <br />
                                    <i className="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>
                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >
                                <b><i className="fa fa-calendar" ></i>&nbsp;&nbsp;&nbsp;8 MONTHS<br />
                                    <i className="fa fa-tasks" id="Description"></i> &nbsp;&nbsp;WEEKEND BATCH</b>
                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">

                                <b><i className=" fa fa-calendar-o" ></i> &nbsp;&nbsp;&nbsp;WEEKDAY&nbsp; (MON - FRI)<br />
                                    <i className=" fa fa-calendar-o" ></i> &nbsp;&nbsp;&nbsp;WEEKEND&nbsp; (SAT - SUN)</b>
                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12">  <hr />
                                <span className="golden">Training Mode(Online)</span><br />
                                <b> <span className="font-for-batch"><i className="fa fa-calendar-o" aria-hidden="true"></i>  Date :20<sup>st</sup> Feb 2021-17<sup>th</sup> Oct 2021 </span></b> <br />
                                <b><span className="font-for-batch"><i className="fa fa-film" aria-hidden="true"></i>  Batch Type :Saturday-Sunday </span></b>
                            </div>
                            <div className="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-12">   <hr />
                                <span className="golden">Training Mode(Online)</span><br />
                                <b> <span className="font-for-batch"><i className="fa fa-calendar-o" aria-hidden="true"></i>  Date :15<sup>th</sup> Feb 2021-09<sup>th</sup> Sep  2021</span></b> <br />
                                <b><span className="font-for-batch"><i className="fa fa-film" aria-hidden="true"></i>  Batch Type :Monday-Friday </span></b>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="def-z">
                    <div className="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Industry">Industry Trends</a></li>
                            <li><a href="#tools">Tools</a></li>
                            <li><a href="#syllabus">Syllabus</a></li>
                            <li><a href="#Certification">Certification</a></li>
                            <li><a href="#Outcomes">Learning Outcomes</a></li>
                            <li><a href="#Schedule">Schedule</a></li>
                            <li><a href="#FAQs">FAQs</a></li>
                            <li className="btn-header cs-dx"><a href="#apply-now">Enroll Now</a> </li>
                        </ul>
                    </div>
                </section>
                <section className="course-description" id="course-description">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="heading-tab">An Overview Of The Post Graduate Program In Data Science</h3>
                            <p align="justify" className="Descriptionbold">The Post Graduate Program in Data Science is jointly created & delivered by Indian Statistical Institute, Pune and edu plus now along with industry experts.</p>
                            <p align="justify"> Our tailor-made curriculum includes functional analytics, SQL, Statistical Analysis, Text Mining, Regression Modeling, Hypothesis Testing, Predictive Analytics, Machine Learning using R, Python, Deep Learning, Neural Networks, Natural Language Processing, Predictive Modeling, Tableau, Spark, Hadoop, etc. which will help you acquire in-demand skills and start a career as an accomplished data scientist.</p>
                        </div>
                    </div><br />
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="heading-tab">Key Features Of The Online Data Science Course</h3>
                            <p align="justify">
                                <ul className="highlight-ss">
                                    <li>	Indian Statistical Institute as a knowledge partner.</li>
                                    <li>	Mentorship by industry specialists.</li>
                                    <li>	Course awarded by Edu Plus Now.</li>
                                </ul>
                            </p>
                        </div>
                        <div className="col-1"> </div>
                    </div>
                    <br />
                    <h3 className="heading-tab">Highlights</h3>
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <table className="table-highlight">
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl7.svg" />  Separate batches for working professional</td>
                                </tr>
                                <tr>
                                    <td><img alt="datascience10" src="/assets/images/icons/hl1.svg" /> Advisory Board members from Industry & Academia </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl2.svg" /> Capstone Project spanning throughout the course
                              duration
                           </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl3.svg" /> Industry-Endorsed Curriculum </td>
                                </tr>
                            </table>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <table className="table-highlight">
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl4.svg" /> Aptitude and Soft Skills Development </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl5.svg" /> Leading Technical Faculty with Domain Expertise </td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl6.svg" /> Placement Assistance</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-sm-12">
                            <h4>Projects</h4>
                        </div>
                        <h6><span className="padding-content1">&nbsp; Real time projects from the following domains</span></h6>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xl-3">
                            <table className="table-highlight">
                                <tr>
                                    <td> <i className="fa fa-stethoscope link-icon btn-title" aria-hidden="true"></i><span className="padding-content"> Healthcare</span></td>
                                </tr>
                                <tr>
                                    <td> <i className="fa fa-search-plus link-icon btn-title" aria-hidden="true"></i><span className="padding-content"> Research & Development</span> </td>
                                </tr>
                                <tr>
                                    <td> <i className="fa fa-laptop link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Information Technology</span> </td>
                                </tr>
                                <tr>
                                    <td><i className="fa fa-user-o link-icon btn-title" aria-hidden="true"></i><span className="padding-content">  Human resource</span></td>
                                </tr>
                                <tr>
                                    <td> <i className="fa fa-cubes link-icon btn-title" aria-hidden="true"></i><span className="padding-content">  Manufacturing</span></td>
                                </tr>
                            </table>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xl-3">
                            <table className="table-highlight">
                                <tr>
                                    <td> <i className="fa fa-wrench link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Maintenance</span></td>
                                </tr>
                                <tr>
                                    <td> <i className="fa fa-shopping-bag link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Retail</span></td>
                                </tr>
                                <tr>
                                    <td><i className="fa fa-link link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Supply Chain</span></td>
                                </tr>
                                <tr>
                                    <td> <i className="fa fa-users link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Trading</span></td>
                                </tr>
                            </table>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xl-3">
                            <table className="table-highlight">
                                <tr>
                                    <td> <i className="fa fa-inr link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Finance</span></td>
                                </tr>
                                <tr>
                                    <td> <img alt="datascience10" src="/assets/images/icons/hl2.svg" />&nbsp;Construction Industry </td>
                                </tr>
                                <tr>
                                    <td><i className="fa fa-address-book link-icon btn-title" aria-hidden="true"></i><span className="padding-content"> Safety</span></td>
                                </tr>
                                <tr>
                                    <td><i className="fa fa-asterisk link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Utility</span></td>
                                </tr>
                            </table>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xl-3">
                            <table className="table-highlight">
                                <tr>
                                    <td><i className="fa fa-id-badge link-icon btn-title" aria-hidden="true"></i> <span className="padding-content"> Insurance</span></td>
                                </tr>
                                <tr>
                                    <td> <i className="fa fa-bar-chart link-icon btn-title" aria-hidden="true"></i><span className="padding-content">Market & Customer Analytics</span></td>
                                </tr>
                                <tr>
                                    <td><img alt="datascience10" src="/assets/images/icons/hl7.svg" /> Sales</td>
                                </tr>
                                <tr>
                                    <td><i className="fa fa-file-excel-o link-icon btn-title" aria-hidden="true"></i><span className="padding-content">  Balance Sheet</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <br />
                    <h3 className="heading-tab">Job Roles According To The Industry You Might Be Interested In </h3>
                    <br />

                    <div className="row">
                        <div className="col-sm-12 col-lg-4 col-xl-4 ">
                            <div className="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/Finance.jpg" className="img-trens" alt="Industry Trends" />
                                <p align="justify">
                                    In the Finance industry, you can work as a strategic decision maker or in the risk analytics department.<br /><br /><br />
                                </p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-lg-4 col-xl-4">
                            <div className="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/bank.jpg" className="img-trens" alt="Industry Trends" />
                                <p align="justify" >
                                    In the Banking industry, you can work as a fraud detector or create models to measure credit risks.<br /><br /><br /><br />
                                </p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-lg-4 col-xl-4">
                            <div className="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/healthcare.jpg" className="img-trens" alt="Industry Trends" />
                                <p align="justify">
                                    In the healthcare industry, you can take up the role of a drug researcher where you can research and discover the drugs that will help in curing a particular disease. You can also become a virtual assistant.
                        </p>
                            </div>
                        </div>
                    </div><br /><br />
                    <div className="row">
                        <div className="col-sm-12 col-lg-4 col-xl-4">
                            <div className="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/E-commerce.jpg" className="img-trens" alt="Industry Trends" />
                                <p align="justify">
                                    In the E-commerce industry, you can work as a researcher who aims at studying consumer behaviours and recommend products to the consumers based on the searching and buying history.
                        </p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-lg-4 col-xl-4">
                            <div className="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/Transport.jpg" className="img-trenst" alt="Industry Trends" />
                                <p align="justify"><br />
                        	In the Transport industry, you can work at the passengers safety department to enhance the safety of the passengers in transit. You can also monitor the transport systems.<br /><br />
                                </p>
                            </div>
                        </div>
                        <div className="col-sm-12 col-lg-4 col-xl-4">
                            <div className="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/manufacturing.jpg" className="img-trens" alt="Industry Trends" />
                                <p align="justify"><br />
                        	In the Manufacturing industry, you can predict the potential problems in the products that are being manufactured or at the automation department of the manufacturing units.<br /><br />
                                </p>
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="heading-tab">Who Will Benefit From The Data Science Certification Course ?</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <ul className="highlight-ss">
                                <li>	Candidates who are willing to learn machine learning algorithms with Python.</li>
                                <li>	Candidates harboring an interest in the practical applications of machine learning to the real-world problems</li>
                                <li>	Students/professionals who wish to understand beyond the basics and gain a holistic understanding of the whole range of machine learning algorithms.</li>
                                <li>	An intermediate or advanced level EXCEL practitioner who is unable to work with extensive datasets.</li>
                                <li>	Anyone who wants to add value to their business through powerful Machine Learning tools.</li>
                                <li>	Budding engineers who want to build a career in Machine Learning.</li>
                                <li id="Industry">	Teachers who are interested in Machine Learning certification.</li>
                                <li>	Industry Professionals who are interested in online Machine Learning courses.</li>
                                <li>	UG/ PG/ PhD students who are looking for Machine Learning training.</li>
                                <li>	Anyone who wants to add machine learning to their area of expertise.</li>
                            </ul>
                        </div>
                    </div>
                    <br></br>
                </section>
                <section className="course-industry-trends bg-secondary" id="course-industry-trends">
                    <div className="row">
                        <div className=" col-md-6 col-sm-12">
                            <h3> Industry Trends </h3>
                            <br />
                            <h5>Job Roles</h5>
                            <ul className="industry-trends-ul">
                                <li>Data Analyst </li>
                                <li>Data Engineer </li>
                                <li>Data Scientist </li>
                                <li>Business Analyst </li>
                                <li id="tools">Machine Learning Engineer </li>
                            </ul>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <img alt="datascience11" src="/assets/images/icons/industry-trends.svg" />
                        </div>
                    </div>
                </section>


                <section className="course-syllabus" id="course-syllabus">
                    <div className="row">
                        <div className="col-sm-6 ">
                            <br />
                            <h3> Syllabus </h3>
                            <br />
                            <div className="syl-bg">
                                <h5>Data Engineering </h5>
                                <div id="de_syllabus">
                                    <div className="panel-group">
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> SQL
                                                </h6>
                                            </div>
                                            <div id="de_syllabus1" className="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li> SQL Overview </li>
                                                        <li> SQL SELECT Statements </li>
                                                        <li> SQL Functions and Expressions </li>
                                                        <li> SQL Updating </li>
                                                        <li> SQL Sub Queries and Unions </li>
                                                        <li> SQL Summarization </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Hadoop
                                                </h6>
                                            </div>
                                            <div id="de_syllabus2" className="collapse show" aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li> Hadoop Architecture</li>
                                                        <li> Basic Features: HDFS Data
                                                        Characteristics
                                       </li>
                                                        <li> Map Reduce Architecture</li>
                                                        <li> HDFS Architecture</li>
                                                        <li>Hive Architecture</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> MongoDB 
                                                </h6>
                                            </div>
                                            <div id="de_syllabus3" className="collapse show" aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Introduction to MongoDB</li>
                                                        <li>Introduction to NoSQL</li>
                                                        <li>Mongodb Query Document</li>
                                                        <li>Creating, Reading and Updating Data</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Spark 
                                                </h6>
                                            </div>
                                            <div id="de_syllabus4" className="collapse show" aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Spark Architecture</li>
                                                        <li>RDD Fundamentals</li>
                                                        <li> Basic Scala Programming</li>
                                                        <li> Spark SQL introduction</li>
                                                        <li> Spark SQL Data frames</li>
                                                        <li> Spark Job Extraction</li>
                                                        <li> Into Spark Streaming</li>
                                                        <li> Intro to Recommendations system</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h5>Data Analytics, Machine Learning & Deep Learning</h5>
                                <div id="damldl_syllabus">
                                    <div className="panel-group">
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading1" data-toggle="collapse"
                                                href="#damldl_syllabus1" aria-expanded="true" aria-controls="damldl_syllabus1">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Statistics Concepts
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus1" className="collapse show" aria-labelledby="damldl_heading1"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Basic Statistical concepts</li>
                                                        <li> Exploratory Data Analyses</li>
                                                        <li> Estimation and hypotheses testing</li>
                                                        <li> Multiple Linear Regressions</li>
                                                        <li> Categorical Data Analyses</li>
                                                        <li> Introduction to Logistic Regression for classNameification and Risk
                                                        Analysis
                                       </li>
                                                        <li> Regression Analysis</li>
                                                        <li> classNameification using Linear and Quadratic Discriminant Analysis
                                       </li>
                                                        <li> classNameification using Support Vector Machines</li>
                                                        <li> Tree Based Methods</li>
                                                        <li> Principal Component Analysis and Factor Analysis </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading2" data-toggle="collapse"
                                                href="#damldl_syllabus2" aria-expanded="true"
                                                aria-controls="#damldl_syllabus2">
                                                <h6 className="panel-title">
                                                  <i className="indicator fa fa-minus"></i> R Studio
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus2" className="collapse show" aria-labelledby="damldl_heading2"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Introduction to R and R studio</li>
                                                        <li> Vectors</li>
                                                        <li> Testing of hypothesis and Confidence Interval</li>
                                                        <li> Linear Regression </li>
                                                        <li> Logistic Regression</li>
                                                        <li> Decision Trees/CART </li>
                                                        <li> Supervised and Unsupervised learning</li>
                                                        <li> Naïve Bayes classNameifier</li>
                                                        <li> Principal Component Analysis</li>
                                                        <li> Factor Analysis</li>
                                                        <li> Discriminant Analysis</li>
                                                        <li> Time Series Analysis</li>
                                                        <li> k-means clustering</li>
                                                        <li> Market Basket Analysis</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading3" data-toggle="collapse"
                                                href="#damldl_syllabus3" aria-expanded="true" aria-controls="damldl_syllabus3">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Advance Excel
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus3" className="collapse show" aria-labelledby="damldl_heading3"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Excel Worksheet Structuring</li>
                                                        <li> Formatting Tips</li>
                                                        <li> Reference Functions</li>
                                                        <li> Pivot Tables, Pivot Charts,Template, Consolidation</li>
                                                        <li> What if Analysis</li>
                                                        <li> Database Functions</li>
                                                        <li> Macro’s </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading4" data-toggle="collapse"
                                                href="#damldl_syllabus4" aria-expanded="true" aria-controls="damldl_syllabus4">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Python Programming
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus4" className="collapse show" aria-labelledby="damldl_heading4"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li> Variables, Data structures & Control flow</li>
                                                        <li> Functions, Procedural Approach,Modules, File Handling</li>
                                                        <li> Algorithms, Debugging & Bug Fixing </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading5" data-toggle="collapse"
                                                href="#damldl_syllabus5" aria-expanded="true" aria-controls="damldl_syllabus5">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Machine Learning using Python
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus5" className="collapse show" aria-labelledby="damldl_heading5"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Machine Learning</li>
                                                        <li> Types of Machine Learning</li>
                                                        <li> Phases of Machine Learning Project</li>
                                                        <li> Doing Machine Learning using Tool</li>
                                                        <li> Machine Learning Ecosystem in Python</li>
                                                        <li> Pandas for Data Preprocessing & Cleanup</li>
                                                        <li> Machine Learning Model Creation</li>
                                                        <li> Machine Learning Algorithms</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="damldl_heading6" data-toggle="collapse"
                                                href="#damldl_syllabus6" aria-expanded="true" aria-controls="damldl_syllabus6">
                                                <h6 className="panel-title">
                                                   <i className="indicator fa fa-minus"></i> Deep Learning
                                                </h6>
                                            </div>
                                            <div id="damldl_syllabus6" className="collapse show" aria-labelledby="damldl_heading6"
                                                data-parent="#damldl_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Setting up the Environment</li>
                                                        <li> Theoretical Foundation of Deep Learning</li>
                                                        <li> Understanding Neural Networks ANN, CNN, RNN</li>
                                                        <li> Natural Language Processing</li>
                                                        <li> Computer Vision</li>
                                                        <li> image processing /text processing</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h5>Data Visualization</h5>
                                <div id="dv_syllabus">
                                    <div className="panel-group">
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="dv_heading1" data-toggle="collapse"
                                                href="#dv_syllabus1" aria-expanded="true" aria-controls="dv_syllabus1">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Tableau
                                 </h6>
                                            </div>
                                            <div id="dv_syllabus1" className="collapse show" aria-labelledby="dv_heading1"
                                                data-parent="#dv_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Introduction</li>
                                                        <li> Visualization Design and Data Types</li>
                                                        <li> Tableau and Data Connections</li>
                                                        <li>Chart Types, Dashboards and Work Sharing </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel panel-info">
                                            <div className="panel-heading" id="dv_heading2" data-toggle="collapse"
                                                href="#dv_syllabus2" aria-expanded="true" aria-controls="dv_syllabus2">
                                                <h6 className="panel-title">
                                                    <i className="indicator fa fa-minus"></i> Power BI
                                 </h6>
                                            </div>
                                            <div id="dv_syllabus2" className="collapse show" aria-labelledby="dv_heading2"
                                                data-parent="#dv_syllabus">
                                                <div className="panel-body">
                                                    <ul className="syllabus-ul">
                                                        <li>Introduction to Power BI</li>
                                                        <li> Extracting Data</li>
                                                        <li> Power Query for Data Transformation</li>
                                                        <li id="Certification"> Power Pivot for Data Modeling</li>
                                                        <li> Data Visualization with Analytics </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div className="row">
                        <div className="col-sm-6">
                            <h3>Learning Outcomes</h3>
                            <br />
                            <ul className="lo-ul">
                                <li>Gain expertise in Data Engineering, Data Analytics Machine learning &
                                DataVisualization.
                                </li>
                                <li>Master descriptive and inferential statistics, hypothesis testing, regression analysis,
                                data blending, data extracts, and forecasting
                                 </li>
                            </ul>
                            <br />
                            <h5 id="Schedule">Assessment </h5>
                            <p align="justify">
                                Periodic assessment and case studies evaluations by the Indian Statistical Institute,Pune (ISI)
                                and edu plus now have been built in throughout the duration of the course.
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <img src="/assets/images/icons/certificate-final.png" alt="Data Science Course in Pune" />
                            <p className="img-below-text text-center">Awarded Jointly by The Indian Statistical Institute,Pune and
                            edu plus now
                            </p>
                        </div>
                    </div>
                </section>
                <Courseschedule />
                <Aboutuslearners />
                <Aluminicompany />
                <section className="courses-feesm">
                    <section className="course-fees" id="course-fees">
                        <div className="row box-sh" >
                            <div className="col-sm-12 col-lg-12	col-xl-5 pd-fee" >
                                <br /><h6>Course Fees :<i className='fa fa-inr ' ></i><b><span id='fee-gst' > 2,00,000</span></b><span className='fee-gst'> (+GST)</span></h6>
                                <Intrestedinprogram/> 
                            </div>
                            <div className="vertical-line-fee"> </div>
                            <div className="col-sm-12 col-lg-12 col-xl-6	 pd-fee">
                                <div className="row">
                                    <div className="col-sm-10"> <br />
                                        <h5>Features </h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <ul className="highlight-ss" >
                                            <li>	Indian Statistical Institute as a knowledge partner.</li>
                                            <li>	Mentorship by industry specialists.</li>
                                            <li>	Course awarded by Edu Plus Now.</li>
                                            <li>Separate batches for working professional</li>
                                            <li>Advisory Board members from Industry & Academia</li>
                                            <li>Capstone Project spanning throughout the course duration</li>
                                            <li>Industry-Endorsed Curriculum</li>
                                        </ul>
                                    </div>
                                    <p>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section className="course-about-instructor bg-secondary " id="course-about-instructor">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3>
                                About the Organization
                                </h3>
                            <br />
                            <img alt="datascience23" width="" src="/assets/images/isi-black.svg" />
                            <br /><br />
                            <p align="justify">It is a Central Government institute, devoted to research, teaching & application of
                            not only statistics and allied sciences, but also the natural sciences, social
                            sciences and their interface with the statistics. Founded by Professor P.C.
                            Mahalanobis in Kolkata on 17th December, 1931, the institute gained the status of
                            an Institution of National Importance by an act of the Indian Parliament in 1959.
                            </p>
                            <br />
                            <p id="FAQs" align="justify">ISI Pune is a unit of Indian Statistical Institute,Pune, active in Teaching, Training,
                            Research and Consulting on application of statistics, operations research & allied
                            science to solve problems of the industry across the spread and depth of the
                            industries. ISI Pune bring sanctity of statistics in the mother initiatives such as
                            TQM, TPM, Six Sigma, Quality Management, Management Systems, Business Management,
                            Data Analytic, Data Science.
                            </p>
                        </div>
                    </div>
                </section>

                <section class="course-faq" id="course-faq">
                    <br />
                    <h3> FAQs </h3>
                    <br />
                    <div class="row">
                        <div class="col-sm-7 bg-secondary">
                            <br />
                            <div id="faqs">
                                <div class="panel-group">
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading1" data-toggle="collapse" href="#faqs1"
                                            aria-expanded="true" aria-controls="faqs1">
                                            <h6 class="panel-title">
                                               <i class="indicator fa fa-minus"></i>  What tools will I learn with this course?
                                            </h6>
                                        </div>
                                        <div id="faqs1" class="collapse show" aria-labelledby="faqs_heading1"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <p></p>
                                                <ul class="faq-ul">
                                                    <li> In this course, you will learn functional analytics, SQL, Statistical Analysis, Text Mining,
                                                    Regression Modelling, Hypothesis Testing, Predictive Analytics, Machine Learning using R,
                                                    Python, Deep Learning, Neural Networks, Natural Language Processing, Predictive
                                                    Modelling, Tableau, Spark, Hadoop, etc. All these tools will help you acquire in-demand skills
                                                    and start a career as an accomplished data scientist.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading2" data-toggle="collapse" href="#faqs2"
                                            aria-expanded="true" aria-controls="faqs2">
                                            <h6 class="panel-title">
                                               <i class="indicator fa fa-plus"></i> How will a course in Data Science benefit me?
                                            </h6>
                                        </div>
                                        <div id="faqs2" class="collapse" aria-labelledby="faqs_heading2"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> The course will help you gain expertise in Data Engineering, Data Analytics Machine learning
                                                    &amp; Data Visualization.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading3" data-toggle="collapse" href="#faqs3"
                                            aria-expanded="true" aria-controls="faqs3">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Who are eligible for the course?
                                            </h6>
                                        </div>
                                        <div id="faqs3" class="collapse" aria-labelledby="faqs_heading3"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> All Graduates / Post Graduates – Engineering, IT, Computer Science, Mathematics, Statistics,
                                                    Actuarial Science, Economics, Life Science, Electronics and MBA (All Streams) are eligible for
                                                    the course.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading4" data-toggle="collapse" href="#faqs4"
                                            aria-expanded="true" aria-controls="faqs4">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Is there a selection process?
                                            </h6>
                                        </div>
                                        <div id="faqs4" class="collapse" aria-labelledby="faqs_heading4"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> There is  No selection process for the course. </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading5" data-toggle="collapse" href="#faqs5"
                                            aria-expanded="true" aria-controls="faqs5">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> What is the course duration?
                                            </h6>
                                        </div>
                                        <div id="faqs5" class="collapse" aria-labelledby="faqs_heading5"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> The course duration is 6 months. There are two separate batches for weekdays and
                                                    weekends.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading6" data-toggle="collapse" href="#faqs6"
                                            aria-expanded="true" aria-controls="faqs6">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Will there be tests and projects?
                                            </h6>
                                        </div>
                                        <div id="faqs6" class="collapse" aria-labelledby="faqs_heading6"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> Periodic assessment and case studies evaluations by the Indian Statistical Institute,Pune (ISI) and
                                                    edu plus now have been built in throughout the duration of the course.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading7" data-toggle="collapse" href="#faqs7"
                                            aria-expanded="true" aria-controls="faqs7">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> What are the career options after this course?
                                            </h6>
                                        </div>
                                        <div id="faqs7" class="collapse" aria-labelledby="faqs_heading7"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> After completing this course, you can work as Data Analyst, Data Engineer, Data Scientist,
                                                    Business Analyst and Machine Learning Engineer in IT Companies, In-house analytics units of
                                                    corporations, Niche analytics firms, MNC financial institutions, Pharma, Retail, Healthcare,
                                                    Oil &amp; Gas Industry, Telecommunication, Insurance &amp; Manufacturing Companies.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading8" data-toggle="collapse" href="#faqs8"
                                            aria-expanded="true" aria-controls="faqs8">
                                            <h6 class="panel-title">
                                                <i class="indicator fa fa-plus"></i> Do you offer placement assistance?
                                            </h6>
                                        </div>
                                        <div id="faqs8" class="collapse" aria-labelledby="faqs_heading8"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> We do offer placement assistance with this course. </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-info">
                                        <div class="panel-heading" id="faqs_heading9" data-toggle="collapse" href="#faqs9"
                                            aria-expanded="true" aria-controls="faqs9">
                                            <h6 class="panel-title">
                                               <i class="indicator fa fa-plus"></i> Will I get a certification after completing the course?
                                            </h6>
                                        </div>
                                        <div id="faqs9" class="collapse" aria-labelledby="faqs_heading9"
                                            data-parent="#faqs">
                                            <div class="panel-body">
                                                <ul class="faq-ul">
                                                    <li> Yes. A certification is awarded Jointly by the Indian Statistical Institute,Pune and edu plus now
                                                    after course completion.
                                       </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3"> </div>
                    </div>
                </section>
                <div class="modal fade bd-example-modal-sm"   id="myModal" role="dialog">
            <div class="modal-dialog modal-md">
               <div class="modal-content">
                  <div class="modal-header" >
                     <span class="close" id="close_form"  data-dismiss="modal">&times;</span>
                     <br />
                  </div>
                  <div class="modal-body">
                     <div class="panel panel-default paper-shadow box_detail" >
                        <h5 class="text-center "> Download The Course Brochure </h5>
                        <form method="post" class="form-row"  onsubmit="return validate()">
                           <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                              required="" autocomplete="on" name="name" id="name" />
                           <b>Your email</b><input class="form-control" type="email" required=""
                              autocomplete="on" name="emaill" id="emaill" />
                           <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                              type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                           <input type="hidden" name="id" id="exd-course-name" value='' / >
                           <input type="hidden" id="backurl" value="" />
                           <br />
                           <div>
                              <div class="form-group">
                                 <div  id="recaptcha" class="g-recaptcha"
                                    data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                 <div id="captcha"></div>
                              </div>
                           </div>
                           <div class="mob_cb">
                              <div>
                              </div>
                              <br />
                              <button class="btn_1 rounded" type="button"   id="exd-download" ><i class="icon-download"></i> Brochure</button>
                           </div>
                           <br />
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>
            </div>
        )
    }
}

export default DataScience;